import { StyleSheet } from 'react-native';
import { useMemo } from 'react';
import { type Theme } from './theme';
import { useTheme } from './ThemeProvider';

export function createNavigationStyles(theme: Theme) {
  return StyleSheet.create({
    webHeader: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingHorizontal: theme.spacing.lg,
      paddingVertical: theme.spacing.md,
      backgroundColor: theme.colors.backgroundPrimary,
      borderBottomWidth: theme.borders.borderWidth,
      borderBottomColor: theme.borders.borderColor,
      zIndex: 9998,
      position: 'relative',
    },
    webHeaderSection: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    webBrandLink: {
      marginRight: theme.spacing.lg,
      paddingVertical: theme.spacing.sm,
    },
    webNavLink: {
      marginHorizontal: theme.spacing.sm,
      paddingVertical: theme.spacing.sm,
      paddingHorizontal: theme.spacing.md,
      borderRadius: theme.radius.radiusSm,
    },
    webNavText: {
      ...theme.typography.md,
      color: theme.colors.textPrimary,
    },
  });
}

export function useNavigationStyles() {
  const theme = useTheme();
  return useMemo(() => createNavigationStyles(theme), [theme]);
}
